import { Link } from "react-router-dom";
import { MEDIA } from "@/lib/media";
import Logo from "@/components/Logo";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-cream">
      <div className="flex flex-col justify-center px-6 sm:px-12 lg:px-20 py-12">
        <div className="max-w-md w-full mx-auto">
          <Logo />
          <h1 className="mt-10 font-display text-3xl sm:text-4xl text-plum">{title}</h1>
          {subtitle && <p className="mt-2 text-mutedplum text-lg">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-[15px] text-mutedplum">{footer}</div>}
          <Link to="/" className="mt-8 inline-block text-sm text-mutedplum hover:text-teal">← Back to home</Link>
        </div>
      </div>
      <div className="hidden lg:block relative">
        <img src={MEDIA.community} alt="Women exercising together" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-plum/40" />
        <div className="absolute bottom-12 left-12 right-12 text-cream">
          <p className="font-script text-3xl text-rose">together</p>
          <p className="font-display text-2xl mt-1 leading-snug">You belong in this circle.</p>
        </div>
      </div>
    </div>
  );
}
